/* eslint-disable no-unused-vars, no-dupe-keys, react/jsx-no-duplicate-props */
// This file is auto-generated by Simple. Edit TysiaIconDelete/view.blocks to change it.
import React from 'react'
import styles from './view.module.css'



/** @type {import('Simple/types.js').View} */
export default function TysiaIconDelete({
  children,
  viewPath = "/DesignSystem/Svgs/TysiaIconDelete",
  alignSelf = "auto",
  marginTop = 0,
  marginBottom = 0,
  marginLeft = 0,
  marginRight = 0,
  opacity = 1,
  width = 24,
  height = 24,
  isAnimated,
  animation = "dash 5s linear forwards",
  strokeDashoffset = 1000,
  strokeDasharray = 1000,
  fill = "#323232"
  
}) {
  return (<React.Fragment
>
<svg
  data-testid="TysiaIconDelete.Svg"
  data-view-path={viewPath}
 viewBox="0 0 24 24"
 style={{'--as-1-11X0YV': alignSelf,'--mt-2-11X0YV': typeof marginTop === 'number' ? `${marginTop}px` : marginTop,'--mb-3-11X0YV': typeof marginBottom === 'number' ? `${marginBottom}px` : marginBottom,'--ml-4-11X0YV': typeof marginLeft === 'number' ? `${marginLeft}px` : marginLeft,'--mr-5-11X0YV': typeof marginRight === 'number' ? `${marginRight}px` : marginRight,'--o-6-11X0YV': opacity,'--w-10-11X0YV': typeof width === 'number' ? `${width}px` : width,'--h-11-11X0YV': typeof height === 'number' ? `${height}px` : height,'--a-7-11X0YV': isAnimated ? animation : "none",'--sd-8-11X0YV': isAnimated ? strokeDashoffset : 0,'--sd-9-11X0YV': isAnimated ? strokeDasharray : 0}}
 className={`views-block ${styles.Svg}`}
>
<path
  data-testid="TysiaIconDelete.SvgPath"
  data-view-path={viewPath}
 d="M16 9v10H8V9h8m-1.5-6h-5l-1 1H5v2h14V4h-3.5l-1-1zM18 7H6v12c0 1.1.9 2 2 2h8c1.1 0 2-.9 2-2V7z"
 style={{'--f-12-11X0YV': fill}}
 className={`views-block ${styles.SvgPath}`}
/>
</svg>
{children}
</React.Fragment>)
}